import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExterWebComProfileComponent } from './exter-web-com-profile.component';
import { RouterModule, Routes } from '@angular/router';

const rutas: Routes = [
    // trust index
    {
        path     : 'wcp/:id',
        component: ExterWebComProfileComponent,
    },
];

@NgModule({
  declarations: [
    ExterWebComProfileComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
  ]
})
export class ExterWebComProfileModule { }
